export default {
  // title
  logs_error_title: 'Error Logs',
  logs_action_title: 'Action Logs',
  logs_protocol_title: 'Protocol Logs',

  logs_action_list_login_event: 'Login Events',
  logs_action_list_customer_event: 'Customer Events',
  logs_action_list_device_operation_event: 'Device Operation Events',
  logs_action_list_device_command_event: 'Device Command Events',
  logs_action_list_device_issue: 'Device Issues',
  logs_action_list_device_model: 'Device Model',
  logs_action_list_site_event: 'Site Events',
  logs_action_list_user_event: 'User Events',

  // order
  logs_error_order_field: [
    {
      value: 0,
      name: 'Default',
    },
    {
      value: 1,
      name: 'Error type',
    },
    {
      value: 2,
      name: 'Error Status',
    },
    {
      value: 3,
      name: 'Error occurrence time',
    },
    {
      value: 4,
      name: 'Created time',
    },
  ],
  logs_action_order_field: [
    {
      value: 0,
      name: 'Default',
    },
    {
      value: 1,
      name: 'Action Type',
    },
    {
      value: 2,
      name: 'Action User',
    },
    {
      value: 3,
      name: 'Action Time',
    },
  ],
  logs_protocol_order_field: [
    {
      value: 0,
      name: 'Default',
    },
    {
      value: 1,
      name: 'SN',
    },
    {
      value: 2,
      name: 'Communication Type',
    },
  ],
  logs_protocol_data_type: {
    0: 'Open command',
    1: 'Close command',
    2: 'Data received',
    3: 'Data send',
  },
  logs_login_type: {
    0: 'Login',
    1: 'Logout',
  },

  logs_logout_reason: {
    0: 'Authentication failed, rejected',
    1: 'User logout',
    2: 'Network broken,timeout',
    3: 'Forces re login',
  },

  // table
  logs_table_user: 'User',
  logs_table_user_id: 'User ID',
  logs_table_user_name: 'User Name',
  logs_table_action_type: 'Action Type',
  logs_table_action_data: 'Action Data',
  logs_table_location: 'Location',
  logs_table_ip: 'IP',
  logs_table_config_name: 'Config Name',
  logs_table_params_data: 'Params Data',
  logs_table_data: 'Data',
  logs_table_time_start: 'Time Start',
  logs_table_time_end: 'Time End',
  logs_table_time: 'Time',
  logs_table_execute_time: 'Execute Time',
  logs_table_execute_start_time: 'Execute Start Time',
  logs_table_execute_end_time: 'Execute End Time',
  logs_table_config_start_time: 'Config Start Time',
  logs_table_config_end_time: 'Config End Time',
  logs_table_execute_end_result: 'Execute Result',
  logs_table_device_id: 'Device ID',
  logs_table_message_name: 'Message Name',
  logs_table_device_sn: 'Device SN',
  logs_table_device_name: 'Device Name',
  logs_table_device_model: 'Device Model',
  logs_table_issue_id: 'Issue ID',
  logs_table_event_type: 'Event Type',
  logs_table_customer_name: 'Customer Name',
  logs_table_login_time: 'Login Time',
  logs_table_logout_time: 'Logout Time',
  logs_table_logout_reason: 'Logout Reason',
  logs_table_success: 'Success',
  logs_table_site_name: 'Site Name',

  // form
  logs_order_type: 'Order Type',
};
